import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import MyLocationIcon from '@material-ui/icons/MyLocation'

const styles = theme => ({
  item: {
    paddingTop: '0px',
    paddingBottom: '0px',
    paddingLeft: '0px',
    paddingRight: '0px'
  }
})

const ServiceLocationsList = props => {
  const { classes, service, handleLocationClicked } = props

  return (
    <div>
      {service.locations.map((location, index) => (
        <ListItem
          key={index}
          className={classes.item}
          button
          primary={location.name}
          onClick={() =>
            handleLocationClicked(
              [location.longitude, location.latitude],
              location.zoom,
              location.maxBounds,
              location.name
            )
          }
        >
          <ListItemIcon>
            <MyLocationIcon />
          </ListItemIcon>
          <ListItemText primary={location.label || location.name} />
        </ListItem>
      ))}
    </div>
  )
}

export default withStyles(styles)(ServiceLocationsList)



// WEBPACK FOOTER //
// ./src/components/ServiceLocationsList.js